export default class CrossSellingEnum {
    static BLOCK = '[data-element="wpet-cross-selling"]'
    static FILTERS = '[data-element="wpet-cross-selling-filters"]'
    static FILTERS_TRIGGER = '[data-element="wpet-cross-selling-filters-trigger"]'
}
